module.exports = __webpack_public_path__ + "Roboto-Light.a990f611f2305dc12965.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Light.eot
// module id = ../../../../../font/roboto/Roboto-Light.eot
// module chunks = styles